import {State, stateNames} from '../state';
import {Dropdown} from './dropdown';

const STATE_OPTIONS_FR: Dropdown<State>[] = Object.entries(stateNames).map(([key, value]) => {
  return {
    name: value.fr,
    value: key as State,
  };
});

export const STATE_OPTIONS_EN: Dropdown<State>[] = Object.entries(stateNames).map(([key, value]) => {
  return {
    name: value.en,
    value: key as State,
  };
});

export const STATE_OPTIONS = {
  en: STATE_OPTIONS_EN,
  fr: STATE_OPTIONS_FR,
};
